<template>
  <div>
    <v-row>
      <v-col class="text-right">
        <v-icon @click="handleOpenTypeDialog(false, {})">mdi-plus</v-icon>
      </v-col>
    </v-row>
    <v-data-table
      :headers="headers"
      :items="typeManagementList"
      :items-per-page="-1"
      :hide-default-footer="true"
      :header-props="{ sortIcon: null }"
    >
      <template v-slot:item="row">
        <tr>
          <td>{{row.item.catId}}</td>
          <td>{{row.item.catName}}</td>
          <td>
            <button @click="handleOpenTypeDialog(true, row.item)">
              <v-icon>mdi-lead-pencil</v-icon>
            </button>
          </td>
          <td>
            <button @click.stop="handleDelete(row.item)">
              <v-icon>mdi-window-close</v-icon>
            </button>
          </td>
        </tr>
      </template>
    </v-data-table>
    <Dialog :title="isEdit ? '修改名稱': '新增類別'" :isVisible="isTypeDialog" @ok="handleSubmit" @cancel="handleCloseDialog">
      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-text-field label="名稱" required v-model="categoryItem.catName" :rules="catNameRule"/>
        </v-form>
      </v-card-text>
    </dialog>
  </div>
</template>

<script>
import Dialog from '@/components/Dialog.vue';
import ruleMixin from '@/minix/ruleMixin';
import api from '@/api';
import Swal from 'sweetalert2';

export default {
  mixins: [ruleMixin],
  components: {
    Dialog,
  },
  data() {
    return {
      valid: true,
      isTypeDialog: false,
      isEdit: false,
      categoryItem: {
        catId: '',
        catName: '',
      },
      deleteId: '',
      headers: [
        { text: 'ID', value: 'catId' },
        { text: '名稱', value: 'catName' },
        { text: '修改', value: 'edit' },
        { text: '刪除', value: 'delete' },
      ],
      typeManagementList: [],
      catNameRule: this.requiredRule('類別'),
    };
  },
  created() {
    this.handleGetList();
  },
  methods: {
    async handleGetList() {
      const { data } = await api.swapInPoint.typeList();
      this.typeManagementList = data || [];
    },
    handleCloseDialog() {
      this.isTypeDialog = false;
      this.$refs.form.reset();
    },
    handleOpenTypeDialog(isEdit, item) {
      this.isEdit = isEdit;
      this.categoryItem = { ...item };
      this.isTypeDialog = true;
    },
    async handleSubmit() {
      if (this.$refs.form.validate()) {
        const parameter = {
          catName: this.categoryItem.catName,
        };
        const { status } = this.isEdit
          ? await api.swapInPoint.typeEdit(this.categoryItem.catId, parameter)
          : await api.swapInPoint.typeAdd(parameter);
        if (status === 1) {
          this.handleGetList();
          this.handleCloseDialog();
          this.categoryItem = {
            catId: '',
            catName: '',
          };
        }
      }
    },
    async handleDelete(item) {
      const { catId } = item;
      await Swal.fire(
        {
          title: '確定要刪除此類別嗎?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: '確定',
          cancelButtonText: '取消',
        },
      ).then(async (result) => {
        if (result.isConfirmed) {
          const { status } = await api.swapInPoint.typeDelete(catId);
          if (status === 1) {
            await Swal.fire({ icon: 'success', title: '刪除成功' });
            await this.handleGetList();
          } else {
            await Swal.fire({ icon: 'warning', title: '刪除失敗，請聯繫系統管理員。' });
          }
        }
      });
    },
  },
};
</script>
